import { render, staticRenderFns } from "./guildInvitation.vue?vue&type=template&id=fae06464&"
import script from "./guildInvitation.vue?vue&type=script&lang=js&"
export * from "./guildInvitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports